/**
 * Tap-to-open for the header dropdowns on pointers that cannot hover.
 *
 * The mega-menu is revealed by :hover, which a touch device never fires. Tapping a
 * parent like "Om MDOCK" therefore just followed the link and the dropdown was
 * unreachable. Here the first tap opens it and the second follows the link, so the
 * parent page is still available.
 *
 * Nothing runs where hover exists — a mouse or trackpad keeps the CSS behaviour, and
 * keyboard users are served by :focus-within, which is not gated by pointer type.
 */
(function () {
  const canHover = window.matchMedia('(hover: hover)');
  if (canHover.matches) return;

  const items = document.querySelectorAll('.site-header__nav-item.has-dropdown');
  if (!items.length) return;

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    const link = item.querySelector('.site-header__nav-link');
    if (link) link.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    items.forEach((item) => {
      if (item !== except) setOpen(item, false);
    });
  }

  items.forEach((item) => {
    const link = item.querySelector('.site-header__nav-link');
    if (!link) return;
    link.setAttribute('aria-expanded', 'false');

    link.addEventListener('click', (event) => {
      // Already open: let the tap through so the parent page stays reachable.
      if (item.classList.contains('is-open')) return;
      event.preventDefault();
      closeAll(item);
      setOpen(item, true);
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.site-header__nav-item.has-dropdown')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
